import React, { Fragment } from 'react';
import { getPriceString } from 'site-modules/shared/utils/price-utils';

/**
 * Returns formatted price and if price is not valid, returns passed default value.
 *
 * This function contains a workaround for the A11Y Screen Reader to announce the "-" symbol when it is in front of a
 * dollar amount.
 *
 * @param {string|number} price
 * @param {string} defaultValue
 * @param {number} minimumFractionDigits
 * @param {number} maximumFractionDigits
 * @returns {JSX.Element|string}
 */
export const getAccessiblePrice = (price, defaultValue, { minimumFractionDigits, maximumFractionDigits } = {}) => {
  if (+price < 0) {
    // by adding the "negative" text (with visually-hidden) and rendering the "-" separately from the price string,
    // the Screen Reader properly announces the "negative" in front of negative dollar amounts.
    return (
      <Fragment>
        <span className="visually-hidden">negative&nbsp;</span>
        <span aria-hidden="true">-</span>
        {getPriceString(Math.abs(price), defaultValue, { minimumFractionDigits, maximumFractionDigits })}
      </Fragment>
    );
  }
  return getPriceString(price, defaultValue, { minimumFractionDigits, maximumFractionDigits });
};
